import { render, staticRenderFns } from "./DetailConfigDialog.vue?vue&type=template&id=a964d900&scoped=true"
import script from "./DetailConfigDialog.vue?vue&type=script&lang=js"
export * from "./DetailConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailConfigDialog.vue?vue&type=style&index=0&id=a964d900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a964d900",
  null
  
)

export default component.exports